import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { FlashSaleBundleTile } from "@faire/retailer-visitor-shared/components/FlashSaleBundleTile/FlashSaleBundleTile";
import { CarouselBase } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import * as React from "react";
export var FlashSaleCarousel = function(props) {
    var CarouselBaseComponent = CarouselBase;
    var _React_useContext = React.useContext(Context), onItemClick = _React_useContext.onItemClick, requestId = _React_useContext.requestId, layoutElement = _React_useContext.layoutElement, onVisible = _React_useContext.onVisible;
    var getItems = function() {
        return layoutElement.layout_element_data.map(function(elementData) {
            return elementData.flash_sale_tile;
        }).filter(isNotUndefined);
    };
    var renderFlashSaleTileCarousel = function(flashSaleTile) {
        return /*#__PURE__*/ _jsx(FlashSaleBundleTile, {
            item: flashSaleTile,
            onClick: function(flashSaleToken) {
                var _layoutElement_on_click_event_name;
                onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId, flashSaleToken);
            }
        }, flashSaleTile.token);
    };
    var onItemsVisible = function(items) {
        var itemTokens = items.map(function(item) {
            return item.token;
        }).filter(isNotUndefined);
        if (layoutElement.on_click_event_name) {
            onVisible === null || onVisible === void 0 ? void 0 : onVisible(layoutElement.on_click_event_name, requestId, itemTokens.join(" "));
        }
    };
    return /*#__PURE__*/ _jsx(CarouselBaseComponent, _object_spread({
        noWrap: true,
        renderItem: renderFlashSaleTileCarousel,
        items: getItems(),
        itemsPerSlide: {
            mobileAndAbove: 1,
            tabletAndAbove: 2,
            desktopAndAbove: 3
        },
        peekNextPercent: {
            mobileAndAbove: 15,
            tabletAndAbove: 0
        },
        onItemsVisible: onItemsVisible
    }, props));
};
